import React from 'react';
import { Scale } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function CostComparison() {
  const comparisons = [{
    without: 'Horas buscando información técnica cada semana',
    cost: 'Tu tiempo. Tu vida.'
  }, {
    without: 'Mecánico que no podés cuestionar',
    cost: 'Miles de pesos de más por año'
  }, {
    without: 'Salir sin revisar nada porque no sabés qué revisar',
    cost: 'Riesgo real en cada viaje'
  }, {
    without: 'Sin entender las luces del tablero',
    cost: 'Daños que se agravan por ignorarlos'
  }, {
    without: 'Sin historial de mantenimiento',
    cost: 'Auto que vale menos cuando lo vendés'
  }, {
    without: 'Sin protocolo de emergencia en ruta',
    cost: 'Quedás tirado sin saber qué hacer'
  }, {
    without: 'Sin sistema para negociar repuestos',
    cost: 'El triple del precio de mercado'
  }];
  return <section className="py-24 relative" aria-label="Comparación de costos" data-id="element-36">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-37">
        <FadeIn data-id="element-38">
          <div className="text-center mb-16" data-id="element-39">
            <Scale className="w-12 h-12 text-gray-400 mx-auto mb-6" aria-hidden="true" data-id="element-40" />
            <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-41">
              ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
            </h2>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-42">
          <div className="bg-surface rounded-2xl border border-white/5 overflow-hidden" data-id="element-43">
            <div className="grid grid-cols-2 bg-surfaceLight p-4 md:p-6 border-b border-white/5" data-id="element-44">
              <div className="font-bold text-gray-400 uppercase tracking-wider text-sm md:text-base" data-id="element-45">
                Sin Mega Pack
              </div>
              <div className="font-bold text-red-400 uppercase tracking-wider text-sm md:text-base pl-4 md:pl-6 border-l border-white/5" data-id="element-46">
                Costo real
              </div>
            </div>

            <div className="divide-y divide-white/5" data-id="element-47">
              {comparisons.map((item, i) => <div key={i} className="grid grid-cols-2 p-4 md:p-6 hover:bg-white/[0.02] transition-colors" data-id="element-48">
                  <div className="text-gray-300 pr-4" data-id="element-49">{item.without}</div>
                  <div className="text-red-300/80 pl-4 md:pl-6 border-l border-white/5 font-medium" data-id="element-50">
                    {item.cost}
                  </div>
                </div>)}
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-51">
          <div className="mt-16 text-center" data-id="element-52">
            <p className="text-xl md:text-2xl text-gray-300 italic" data-id="element-53">
              🚗 "El próximo viaje puede ser diferente."{' '}
              <br className="hidden md:block" data-id="element-54" />
              <span className="text-cyan font-medium not-italic mt-2 block" data-id="element-55">
                Porque tu auto te lleva al trabajo, a tu familia, a tu vida.
                Pero solo si lo cuidás bien.
              </span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}